export function values<T extends object>(object: T): Array<T[keyof T]> {
    return Object.values(object)
}
